import React, { useState, useMemo } from "react";
import FiltroNegociacoes from "~pages/PricesTableV2/components/filters/FiltroNegociacoes";
import { FormProvider, useForm } from "react-hook-form";
import { getStoragekeysNegociations } from "~pages/PricesTableV2/helpers/storage";

import useModal from "~components/Modal/hooks/useModal";
import useTabelaSolicitacoes from "~fetchs/useTabelaSolicitacoes";
import useSimuladorSolicitacoes from "~fetchs/useSimuladorSolicitacoes";
import useNegociacaoPrecoRegra from "~/fetchs/useNegociacaoPrecoRegra";
import PricesTableSolicitarNegociacaoModal from "~pages/PricesTableV2/components/Modal/SolicitarNegociacaoModal";
import SolicitacoesListagem from "~pages/PricesTableV2/components/Solicitacoes/SolicitacoesListagem";
import { SaveIndexBD } from "~services/utils/SaveIndexBD";
import { initialPath } from "~misc/paths";
import { useNavigate } from "react-router-dom";

const RequestsPage = () => {
  const keys = useMemo(() => getStoragekeysNegociations("solicitations"), []);

  const [skip, setSkip] = useState(0);
  const take = 5;
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const navigate = useNavigate();

  const [dadosHeader, setDadosHeader] = useState({});
  const { isModalOpen, closeModal, setModalOpen } = useModal();

  const handleAddButton = (grupoProdutoId, produtoId, filialId, clienteId, origem) => {
    const dadosHeader = { grupoProdutoId, produtoId, filialId, clienteId, origem };

    if (origem === "editar" && clienteId) {
      SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
      navigate(`${initialPath}/tabela-preco/${clienteId}/editar-negociacao`);
      return;
    }

    if (origem === "nova" && clienteId) {
      SaveIndexBD("dados-selecionados-negociacao", dadosHeader);
      navigate(`${initialPath}/tabela-preco/${clienteId}/nova-negociacao`);
      return;
    }

    setModalOpen(true);
    setDadosHeader(dadosHeader);
  };

  const getDefaultValues = () => {
    try {
      const savedCliente = localStorage.getItem(keys.cliente);
      const savedProduto = localStorage.getItem(keys.produto);
      const savedGrupoProduto = localStorage.getItem(keys.grupoProduto);
      const savedFilial = localStorage.getItem(keys.filiais);
      const savedNegociacao = localStorage.getItem(keys.negociacao);
      const savedStatus = localStorage.getItem(keys.status);
      const savedPeriodo = localStorage.getItem(keys.periodo);

      return {
        cliente: savedCliente ? JSON.parse(savedCliente).value : 0,
        grupoProduto: savedGrupoProduto ? JSON.parse(savedGrupoProduto).value : 0,
        produto: savedProduto ? JSON.parse(savedProduto).value : 0,
        filial: savedFilial ? JSON.parse(savedFilial).value : 0,
        tipoSolicitacao: savedNegociacao ? JSON.parse(savedNegociacao).value : 0,
        ordem: "recentes",
        statusSolicitacao: savedStatus ? JSON.parse(savedStatus)?.value : -1,
        periodo: savedPeriodo ? JSON.parse(savedPeriodo) : { value: 0, label: "Todos", startDate: null, endDate: null },
      };
    } catch (error) {
      console.warn("Error loading filters from localStorage:", error);
      return {
        cliente: 0,
        grupoProduto: 0,
        produto: 0,
        filial: 0,
        tipoSolicitacao: 0,
        ordem: "recentes",
        statusSolicitacao: -1,
        periodo: { value: 0, label: "Todos", startDate: null, endDate: null },
      };
    }
  };

  const methods = useForm({
    defaultValues: getDefaultValues(),
  });

  const cliente = methods.watch("cliente");
  const grupoProduto = methods.watch("grupoProduto");
  const produto = methods.watch("produto");
  const filial = methods.watch("filial");
  const tipoSolicitacao = methods.watch("tipoSolicitacao");
  const ordem = methods.watch("ordem");
  const statusSolicitacao = methods.watch("statusSolicitacao");
  const periodo = methods.watch("periodo");

  const filters = useMemo(
    () => ({
      cliente: cliente || 0,
      grupoProduto: grupoProduto || 0,
      produto: produto || 0,
      filial: filial || 0,
      tipoSolicitacao: tipoSolicitacao || 0,
      ordem: ordem || "recentes",
      statusSolicitacao: statusSolicitacao || -1,
      periodo: periodo?.value || 0,
      startDate: periodo?.startDate || null,
      endDate: periodo?.endDate || null,
    }),
    [cliente, grupoProduto, produto, filial, tipoSolicitacao, ordem, statusSolicitacao, periodo]
  );

  const { negociacoesAll } = useNegociacaoPrecoRegra({ skip, take });
  const { solicitacoes, carregando } = useSimuladorSolicitacoes({});
  const { solicitacoesQuery, solicitacoesQueryAll } = useTabelaSolicitacoes({
    filters,
    skip,
    take,
    setLoading,
    negociacoes: negociacoesAll,
    solicitacoes,
    setLoadingSearch,
  });

  return (
    <FormProvider {...methods}>
      <form>
        <FiltroNegociacoes
          nomeDoFiltro="solicitations"
          clientesDisponiveis={[]}
          hideSelectAll
          useCustomOrder
          filters={filters}
          solicitacao
          loadingx={loadingSearch}
        />

        <SolicitacoesListagem
          handleAddButton={handleAddButton}
          solicitacoes={solicitacoesQuery || []}
          solicitacoesAll={solicitacoesQueryAll}
          loading={loading}
          skip={skip}
          take={take}
          setSkip={setSkip}
          setLoading={setLoading}
          carregando={carregando}
        />

        <PricesTableSolicitarNegociacaoModal isOpen={isModalOpen} closeModal={closeModal} dadosHeader={dadosHeader} />
      </form>
    </FormProvider>
  );
};

export default RequestsPage;
